import React from 'react';

class ChatwootWidget extends React.Component {
    componentDidMount() {

        // Disable Chatwoot in development mode or if host is localhost
        if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
            return;
        }
        
        // Add Chatwoot Settings
        window.chatwootSettings = {
            hideMessageBubble: false,
            position: 'right', // This can be left or right
            locale: 'en', // Language to be set
            type: 'standard', // [standard, expanded_bubble]
        };

        // Paste the script from inbox settings except the <script> tag
        (function (d, t) {
            var BASE_URL = "https://helpdesk.nphl.go.ke";
            var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
            g.src = BASE_URL + "/packs/js/sdk.js";
            s.parentNode.insertBefore(g, s);
            g.async = !0;
            g.onload = function () {
                window.chatwootSDK.run({
                    websiteToken: 'vQ3cFZe219LYfAJvpPTXrNHs',
                    baseUrl: BASE_URL
                })
            }
        })(document, "script");
    }

    render() {
        return null;
    }
}

export default ChatwootWidget